"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sCurve = void 0;
const sCurve = (currentPoint, midPoint, steepness) => {
    return 1 / (1 + Math.exp(-steepness * (currentPoint - midPoint)));
};
exports.sCurve = sCurve;
